var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractAuthenticatedService from '../../../model/service/abstract-authenticated-service';
import DeleteRuleTask from '../../task/mapping/rule/delete-rule-task';
import GetRuleTask from '../../task/mapping/rule/get-rule-task';
import GetRulesTask from '../../task/mapping/rule/get-rules-task';
import PostRuleTask from '../../task/mapping/rule/post-rule-task';
import PutRuleTask from '../../task/mapping/rule/put-rule-task';
export default class RuleService extends AbstractAuthenticatedService {
    /**
     * Find rules using search conditions
     * @param searchConditions
     * @returns
     */
    findRules(searchConditions) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetRulesTask();
            task.token = this.token;
            task.searchConditions = searchConditions;
            const results = yield this.runTask(task);
            return results;
        });
    }
    /**
     * Find rules for a data source
     * @param dataSourceId
     * @returns
     */
    findRulesUsingDataSourceId(dataSourceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchConditions = {
                dataSourceId,
            };
            return this.findRules(searchConditions);
        });
    }
    /**
     * Load a single rule
     * @param id
     * @returns
     */
    loadRule(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetRuleTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Create a new rule
     *
     * @param rule
     * @returns
     */
    createRule(rule) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PostRuleTask();
            task.token = this.token;
            task.rule = rule;
            return this.runTask(task);
        });
    }
    /**
     * Update a rule
     *
     * @param rule
     * @returns
     */
    updateRule(rule) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PutRuleTask();
            task.token = this.token;
            task.rule = rule;
            return this.runTask(task);
        });
    }
    /**
     * Save a rule
     *
     * @param rule
     * @returns Rule
     */
    saveRule(rule) {
        return __awaiter(this, void 0, void 0, function* () {
            // If it already has an id
            if (rule.id) {
                // Update the rule
                return yield this.updateRule(rule);
            }
            else {
                // Add a new rule
                return yield this.createRule(rule);
            }
        });
    }
    /**
     * Delete a rule
     *
     * @param id
     * @returns
     */
    deleteRule(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new DeleteRuleTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Load a rule from the string endpoint
     * E.g. /rules/ee96df5c-c346-43c4-b321-de63ffb4d638
     *
     * @param endpoint
     * @returns
     */
    loadRuleFromEndpoint(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            const ruleId = endpoint.replace('/rules/', '');
            return this.loadRule(ruleId);
        });
    }
}
//# sourceMappingURL=rule-service.js.map